import { CommunityProfile, ProProfile, ShopProfile } from './model';

export function isCommunityProfile(profile: ProProfile): profile is CommunityProfile {
  return profile.type === 'community';
}

export function isShopProfile(profile: ProProfile): profile is ShopProfile {
  return profile.type === 'shop';
}
